import React, { useState } from 'react';
import Sidebar from '../Components/Sidebar';
import MobileNav from '../Components/MobileNav'; // ADD THIS
import { useIsMobile } from '../hooks/useMediaQuery'; // ADD THIS
import { useLanguage } from '../context/LanguageContext';

export default function Help() {
  const { t } = useLanguage();
  const isMobile = useIsMobile(); // ADD THIS
  
  const [collapsed, setCollapsed] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeSection, setActiveSection] = useState('help');

  const helpTopics = [
    {
      id: 1,
      question: "How do I join a clan?",
      answer: "Go to the Clan section and select a clan to join their WhatsApp group."
    },
    {
      id: 2,
      question: "How do I update my rank?",
      answer: "Go to Profile Settings and select your current rank from the dropdown."
    },
    {
      id: 3,
      question: "How do I follow other players?",
      answer: "Visit any player profile and click the Follow button."
    },
    {
      id: 4,
      question: "What is IGD?",
      answer: "IGD (In-Game Data) tracks your awards, kills, deaths, suicides, and betrayals."
    },
    // REMOVED: Premium question
  ];

  const filteredTopics = helpTopics.filter(topic => 
    topic.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
    topic.answer.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const renderHelpContent = () => (
    <div>
      <h2 style={{ 
        marginBottom: isMobile ? '16px' : '20px', 
        color: 'var(--text)',
        fontSize: isMobile ? '20px' : '24px',
      }}>
        {t('helpTopics')}
      </h2>
      
      {/* Search */}
      <div style={{ marginBottom: isMobile ? '20px' : '30px' }}>
        <input
          type="text"
          placeholder={t('search') + "..."}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            width: '100%',
            padding: isMobile ? '14px 18px' : '15px 20px',
            borderRadius: '9999px',
            border: '1px solid var(--border)',
            background: 'var(--input-bg)',
            color: 'var(--text)',
            fontSize: '16px', // Prevents iOS zoom
            outline: 'none',
            minHeight: '48px', // Touch target
            boxSizing: 'border-box',
          }}
        />
      </div>

      {/* Topics List */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? '12px' : '15px' }}>
        {filteredTopics.map(topic => (
          <div
            key={topic.id}
            style={{
              background: 'var(--bg)',
              padding: isMobile ? '16px' : '20px',
              borderRadius: isMobile ? '10px' : '12px',
              border: '1px solid var(--border)',
            }}
          >
            <h3 style={{ 
              color: '#38bdf8', 
              marginBottom: isMobile ? '8px' : '10px',
              fontSize: isMobile ? '15px' : '16px',
              lineHeight: '1.4',
            }}>
              {topic.question}
            </h3>
            <p style={{ 
              color: '#64748b', 
              lineHeight: '1.6',
              fontSize: isMobile ? '14px' : '14px',
            }}>
              {topic.answer}
            </p>
          </div>
        ))}
        {filteredTopics.length === 0 && (
          <p style={{ color: '#64748b', textAlign: 'center', padding: '20px' }}>
            No results found.
          </p>
        )}
      </div>

      <div style={{ 
        marginTop: isMobile ? '24px' : '30px', 
        paddingTop: isMobile ? '16px' : '20px', 
        borderTop: '1px solid var(--border)' 
      }}>
        <h3 style={{ 
          color: '#38bdf8', 
          marginBottom: isMobile ? '8px' : '10px',
          fontSize: isMobile ? '15px' : '16px',
        }}>
          {t('contactSupport')}
        </h3>
        <p style={{ 
          color: '#64748b',
          fontSize: isMobile ? '14px' : '14px',
        }}>
          Email: support@wwmmcgc.com
        </p>
      </div>
    </div>
  );

  const renderAboutContent = () => (
    <div>
      <h2 style={{ 
        marginBottom: isMobile ? '16px' : '20px', 
        color: 'var(--text)',
        fontSize: isMobile ? '20px' : '24px',
      }}>
        {t('about')}
      </h2>
      
      <div style={{ 
        lineHeight: '1.8', 
        color: '#64748b',
        fontSize: isMobile ? '14px' : '15px',
      }}>
        <h3 style={{ 
          color: '#38bdf8', 
          marginBottom: isMobile ? '8px' : '10px',
          fontSize: isMobile ? '16px' : '18px',
        }}>
          What is WWMMCGC?
        </h3>
        <p style={{ marginBottom: isMobile ? '16px' : '20px' }}>
          WWMMCGC (World Wide Mini Militia Classic Global Community) is a global
          gaming community built to connect Mini Militia players worldwide.
          It provides a platform for players to showcase their profiles,
          follow other gamers, and build strong competitive clans.
        </p>

        <h3 style={{ 
          color: '#38bdf8', 
          marginBottom: isMobile ? '8px' : '10px',
          fontSize: isMobile ? '16px' : '18px',
        }}>
          Our Mission
        </h3>
        <p style={{ marginBottom: isMobile ? '16px' : '20px' }}>
          To unite Mini Militia players across the globe and create
          a competitive, respectful, and fun environment for everyone.
        </p>

        <h3 style={{ 
          color: '#38bdf8', 
          marginBottom: isMobile ? '8px' : '10px',
          fontSize: isMobile ? '16px' : '18px',
        }}>
          Our Vision
        </h3>
        <p>
          To become the largest and most organized Mini Militia
          community platform and expand into other competitive gaming networks.
        </p>
      </div>
    </div>
  );

  const renderLegalContent = () => (
    <div>
      <h2 style={{ 
        marginBottom: isMobile ? '16px' : '20px', 
        color: 'var(--text)',
        fontSize: isMobile ? '20px' : '24px',
      }}>
        {t('legal')}
      </h2>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? '16px' : '20px' }}>
        <div style={{ 
          background: 'var(--bg)', 
          padding: isMobile ? '16px' : '20px', 
          borderRadius: isMobile ? '10px' : '12px',
          border: '1px solid var(--border)',
        }}>
          <h3 style={{ 
            color: '#38bdf8', 
            marginBottom: isMobile ? '8px' : '10px',
            fontSize: isMobile ? '15px' : '16px',
          }}>
            {t('terms')}
          </h3>
          <p style={{ 
            color: '#64748b', 
            lineHeight: '1.6',
            fontSize: isMobile ? '14px' : '14px',
          }}>
            By using WWMMCGC, you agree to respect other players,
            avoid abusive behavior, and not misuse the platform.
            Any violation may result in account suspension.
          </p>
        </div>

        <div style={{ 
          background: 'var(--bg)', 
          padding: isMobile ? '16px' : '20px', 
          borderRadius: isMobile ? '10px' : '12px',
          border: '1px solid var(--border)',
        }}>
          <h3 style={{ 
            color: '#38bdf8', 
            marginBottom: isMobile ? '8px' : '10px',
            fontSize: isMobile ? '15px' : '16px',
          }}>
            {t('privacyPolicy')}
          </h3>
          <p style={{ 
            color: '#64748b', 
            lineHeight: '1.6',
            fontSize: isMobile ? '14px' : '14px',
          }}>
            We collect basic account information such as email,
            profile details, and follow relationships.
            Your data is securely stored using Supabase.
            We do not sell or share your personal information.
          </p>
        </div>
      </div>
    </div>
  );

  // Mobile tab selector (bottom tabs or dropdown style)
  const renderMobileTabs = () => (
    <div style={{
      display: 'flex',
      gap: '8px',
      marginBottom: '20px',
      overflowX: 'auto',
      padding: '4px',
      WebkitOverflowScrolling: 'touch',
    }}>
      {[
        { id: 'help', label: t('helpTopics'), icon: '❓' },
        { id: 'about', label: t('about'), icon: 'ℹ️' },
        { id: 'legal', label: t('legal'), icon: '⚖️' }
      ].map(tab => (
        <div
          key={tab.id}
          onClick={() => setActiveSection(tab.id)}
          style={{
            padding: isMobile ? '12px 16px' : '15px',
            borderRadius: '10px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            background: activeSection === tab.id ? 'rgba(56, 189, 248, 0.1)' : 'var(--bg)',
            color: activeSection === tab.id ? '#38bdf8' : 'var(--text)',
            fontWeight: activeSection === tab.id ? 'bold' : 'normal',
            fontSize: isMobile ? '14px' : '14px',
            whiteSpace: 'nowrap',
            border: '1px solid var(--border)',
            minHeight: '44px', // Touch target
          }}
        >
          <span>{tab.icon}</span>
          {tab.label}
        </div>
      ))}
    </div>
  );

  return (
    <div style={{ 
      display: 'flex', 
      background: 'var(--bg)', 
      minHeight: '100vh',
      color: 'var(--text)',
      flexDirection: isMobile ? 'column' : 'row',
    }}>
      {!isMobile && <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />}
      
      <div style={{ 
        flex: 1, 
        marginLeft: isMobile ? '0' : (collapsed ? '80px' : '280px'),
        padding: isMobile ? '16px' : '40px',
        paddingBottom: isMobile ? '90px' : '40px',
        transition: 'margin-left 0.3s ease',
        overflowX: 'hidden',
      }}>
        <h1 style={{ 
          fontSize: isMobile ? '24px' : '32px', 
          fontWeight: 'bold', 
          marginBottom: isMobile ? '20px' : '30px',
        }}>
          {t('help')}
        </h1>

        {isMobile ? (
          // Mobile Layout: Horizontal tabs on top, content below
          <>
            {renderMobileTabs()}
            <div style={{ 
              background: 'var(--card-bg)', 
              borderRadius: '12px',
              padding: isMobile ? '20px' : '30px',
              minHeight: isMobile ? '300px' : '500px',
            }}>
              {activeSection === 'help' && renderHelpContent()}
              {activeSection === 'about' && renderAboutContent()}
              {activeSection === 'legal' && renderLegalContent()}
            </div>
          </>
        ) : (
          // Desktop Layout: Sidebar tabs + content side by side
          <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap' }}>
            {/* Sidebar Tabs */}
            <div style={{ 
              width: '250px', 
              background: 'var(--card-bg)', 
              borderRadius: '12px',
              padding: '10px',
              height: 'fit-content',
            }}>
              {[
                { id: 'help', label: t('helpTopics'), icon: '❓' },
                { id: 'about', label: t('about'), icon: 'ℹ️' },
                { id: 'legal', label: t('legal'), icon: '⚖️' }
              ].map(tab => (
                <div
                  key={tab.id}
                  onClick={() => setActiveSection(tab.id)}
                  style={{
                    padding: '15px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    background: activeSection === tab.id ? 'rgba(56, 189, 248, 0.1)' : 'transparent',
                    color: activeSection === tab.id ? '#38bdf8' : 'var(--text)',
                    fontWeight: activeSection === tab.id ? 'bold' : 'normal',
                    marginBottom: '5px',
                  }}
                >
                  <span>{tab.icon}</span>
                  {tab.label}
                </div>
              ))}
            </div>

            {/* Content Area */}
            <div style={{ 
              flex: 1, 
              background: 'var(--card-bg)', 
              borderRadius: '12px',
              padding: '30px',
              minHeight: '500px',
            }}>
              {activeSection === 'help' && renderHelpContent()}
              {activeSection === 'about' && renderAboutContent()}
              {activeSection === 'legal' && renderLegalContent()}
            </div>
          </div>
        )}
      </div>
      
      {isMobile && <MobileNav />}
    </div>
  );
}